/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Popover, PopoverBody } from 'reactstrap';
import Clickable from '../clickable/Clickable';
import Modal from '../modal/modal';
import FileSlider from '../photoCarousel/FileSlider';
import styles from './attachments.module.scss';
import style from '../../modules/SafetyPromotions/safetyPromotion.module.scss';
import Collapsible from '../collapsible/Collapsible';
import fileicon from '../../icons/thumbnail.png';
import pdficon from '../../icons/pdf.png';
import docicon from '../../icons/doc.png';
import xlsicon from '../../icons/xls.png';
import ppticon from '../../icons/ppt.png';
import jpgIcon from '../../icons/jpg.png';

const AttachmentDetail = ({ attachments, title, extra_data, field, intl, displayLink, defaultPrint, noName, badgingCustomAttachments, adp }) => {
  const [modal, setModal] = useState(false);
  const [initialSlide, setInitialSlide] = useState();
  const [popoverData, setPopoverData] = useState({
    isOpenPopover: false,
    selectedId: ''
  });

  const handleLongDescription = e => (
    <>
    <div
      id={`popover${e?.id}`}
      style={{ cursor: 'pointer', wordWrap: 'break-word' }}
    >
    {e.file_name?.substring(0, 10)}{' '}{'...'}
    </div>
    <Popover trigger="hover legacy"
      placement="right"
      isOpen={popoverData?.selectedId === e?.id && popoverData?.isOpenPopover}
      target={`popover${e?.id}`}
      toggle={() => setPopoverData(st => ({ isOpenPopover: !st.isOpenPopover, selectedId: e?.id }))}
      className={style.desPopover}
      >
      <PopoverBody style={{ padding: '10px 10px 10px 15px' }}>
       <span className={style.popoverDes}>{e.file_name || e.name}</span>
      </PopoverBody>
    </Popover>
    </>
  );
const openPhotoModal = (idx) => {
    setModal(true);
    setInitialSlide(idx);
  };

  const handleImageName = (name, val) => {
   const imageName= name.length > 10
      ? handleLongDescription(val)
      : name;
      return imageName;
  };

  return (
      <>
        {attachments.length > 0 && !displayLink && !defaultPrint && (
        <div
          className={`${defaultPrint ? `${styles.defaultPrint} ${styles.requestInfoField}` : styles.requestInfoField} ${adp && styles.adpView}`}
        >
          {title && (
            <span className={styles.title}>
              {title}
            </span>
          )}
            <div className={adp ? styles.vphotos : styles.viewphotos} style={{ marginTop: badgingCustomAttachments ? '20px' : '0px' }}>
              {attachments.map((e, idx) => (
                <Clickable
                  key={e.id}
                  onClick={() => openPhotoModal(idx)}
                >
                  {((e.type || e.content_type)?.includes('image')) && (
                    <div className={styles.filecontent}>
                    <img className={styles.photoicon} src={e.url || e.preview} alt={e.file_name || e.name} />
                    <div className={styles.filedescription}>
                      <img className={styles.pdficon} src={jpgIcon} alt={e.file_name || e.name} />
                      <p className={styles.pdfdescription}>
                      {handleImageName(e.file_name || e.name, e)}
                      </p>
                    </div>
                    </div>
                  )}
                  {((e.type || e.content_type)?.includes('pdf')) && (
                    <div className={styles.filecontent}>
                      <img className={styles.fileicon} src={fileicon} alt={e.file_name || e.name} />
                      <div className={styles.filedescription}>
                        <img className={styles.pdficon} src={pdficon} alt={e.file_name || e.name} />
                        <p className={styles.pdfdescription}>
                        {handleImageName(e.file_name || e.name, e)}
                        </p>
                      </div>
                    </div>
                  )}
                  {((e.type || e.content_type)?.includes('msword') || (e.type || e.content_type)?.includes('officedocument')) && (
                    <div className={styles.filecontent}>
                      <img className={styles.fileicon} src={fileicon} alt={e.file_name || e.name} />
                      <div className={styles.filedescription}>
                        <img className={styles.pdficon} src={docicon} alt={e.file_name || e.name} />
                        <p className={styles.pdfdescription}>
                        {handleImageName(e.file_name || e.name, e)}
                        </p>
                      </div>
                    </div>
                  )}
                  {((e.type || e.content_type)?.includes('powerpoint')) && (
                    <div className={styles.filecontent}>
                      <img className={styles.fileicon} src={fileicon} alt={e.file_name || e.name} />
                      <div className={styles.filedescription}>
                        <img className={styles.pdficon} src={ppticon} alt={e.file_name || e.name} />
                        <p className={styles.pdfdescription}>
                        {handleImageName(e.file_name || e.name, e)}
                        </p>
                      </div>
                    </div>
                  )}
                  {((e.type || e.content_type)?.includes('excel')) && (
                    <div className={styles.filecontent}>
                      <img className={styles.fileicon} src={fileicon} alt={e.file_name || e.name} />
                      <div className={styles.filedescription}>
                        <img className={styles.pdficon} src={xlsicon} alt={e.file_name || e.name} />
                        <p className={styles.pdfdescription}>
                        {handleImageName(e.file_name || e.name, e)}
                        </p>
                      </div>
                    </div>
                  )}
                </Clickable>
              ))}
            </div>
          {field?.enable_badge_scan && !Array.isArray(extra_data) && extra_data && Object.keys(extra_data)?.length > 0 && (
            <Collapsible
              title="View Details"
              styleClasses={styles.viewDetails}
            >
              {Object.keys(extra_data)?.map(ef => (
                <>
                  <span>
                    {intl.formatMessage({ id: `extra_fields.forms.${ef}`, defaultMessage: ef?.toUpperCase() })}:
                    <p style={{ color: 'black' }}>&nbsp;&nbsp;{extra_data?.[ef]}</p>
                  </span>
                </>
              ))}
            </Collapsible>
          )}
          {field?.enable_badge_scan && Array.isArray(extra_data) && extra_data?.length > 0 && (
            <div>
              {extra_data?.map(badge => (
                <Collapsible
                  title="View Details"
                  styleClasses={styles.viewDetails}
                >
                  {badge && Object.keys(badge)?.map(ef => (
                    <>
                      <span>
                        {intl.formatMessage({ id: `extra_fields.forms.${ef}`, defaultMessage: ef?.toUpperCase() })}:
                        <p style={{ color: 'black' }}>&nbsp;&nbsp;{badge?.[ef]}</p>
                      </span>
                    </>
                  ))}
                </Collapsible>
              ))}
            </div>
          )}
        </div>
        )}
        {displayLink && attachments.length > 0 && !defaultPrint && (
          <Clickable
            onClick={() => openPhotoModal(0)}
            className={styles.link}
          >
            <FormattedMessage defaultMessage="View Uploads" id="flow.detail.view_uploads" tagName="p" />
          </Clickable>
        )}
        {attachments?.length !== 0 && defaultPrint
          && <div className={`${styles.defaultPrint} ${styles.printphotos}`}>
            {title && (
            <span className={styles.title}>
              {title}
            </span>
          )}
              <div>
                {attachments.map(e => (
                <div className={styles.printAttachments}>
                  {((e.type || e.content_type)?.includes('image'))
                   && <>
                    {!noName && (
                      <img className={styles.photoicon} src={e.url || e.preview} alt={e.file_name || e.name} />
                    )}
                        <div className={styles.filedescription}>
                          <img className={styles.pdficon} src={jpgIcon} alt={e.file_name || e.name} />
                            {!noName && (
                              <p className={styles.pdfdescription}>
                                {e.file_name || e.name}
                              </p>
                            )}
                        </div>
                      </>
                  }
                  {((e.type || e.content_type)?.includes('pdf')) && (
                    <div className={styles.filedescription}>
                      <img className={styles.pdficon} src={pdficon} alt={e.file_name || e.name} />
                      {!noName && (
                        <>
                          <p className={styles.pdfdescription}>
                            {e.file_name || e.name}
                          </p>
                        </>
                      )}
                    </div>
                  )}
                  {((e.type || e.content_type)?.includes('msword') || (e.type || e.content_type)?.includes('officedocument')) && (
                    <div className={styles.filedescription}>
                      <img className={styles.pdficon} src={docicon} alt={e.file_name || e.name} />
                      {!noName && (
                        <>
                          <p className={styles.pdfdescription}>
                            {e.file_name || e.name}
                          </p>
                        </>
                      )}
                    </div>
                  )}
                  {((e.type || e.content_type)?.includes('powerpoint')) && (
                    <div className={styles.filedescription}>
                      <img className={styles.pdficon} src={ppticon} alt={e.file_name || e.name} />
                      {!noName && (
                        <>
                          <p className={styles.pdfdescription}>
                            {e.file_name || e.name}
                          </p>
                        </>
                      )}
                    </div>
                  )}
                  {((e.type || e.content_type)?.includes('excel')) && (
                    <div className={styles.filedescription}>
                      <img className={styles.pdficon} src={xlsicon} alt={e.file_name || e.name} />
                      {!noName && (
                        <p className={styles.pdfdescription}>
                          {e.file_name || e.name}
                        </p>
                      )}
                    </div>
                  )}
                </div>))
                }
              </div>
             </div>
        }
        {attachments.length > 0 && (
          <Modal
            showIn={modal}
            onClose={() => setModal(false)}
            contentStyles={{
              overflow: 'visible',
              background: '#E6EAEE',
              padding: '20px 40px'
            }}
          >
            <div>
              {attachments.length > 0 && (
                <FileSlider photos={attachments} initialSlide={initialSlide} />
              )}
            </div>
          </Modal>
        )}
      </>
  );
};

AttachmentDetail.propTypes = {
  attachments: PropTypes.shape([]),
  id: PropTypes.string.isRequired
};

AttachmentDetail.defaultProps = {
  attachments: []
};

export default injectIntl(AttachmentDetail);
